import { GeneratedContent } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export const generatedContentApi = createApi({
  reducerPath: 'generatedContentApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getGeneratedContent: build.query<GeneratedContent, string>({
      query: (id) => `generated-content/${id}`,
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    createGeneratedContent: build.mutation<GeneratedContent, GeneratedContent>({
      query: (data) => ({
        url: 'generated-content',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useGetGeneratedContentQuery, useCreateGeneratedContentMutation } =
  generatedContentApi;
